export default {
  id: "yeye-saviour",
  pride: 12288,
  slug: "yeye-saviour",
  category: "game",
  status: "released",
  titleKey: {
    zh: "爷爷救世主",
    en: "YeYe Saviour"
  },
  image: "https://ggj.s3.amazonaws.com/styles/game_sidebar__wide/featured_image/2019/01/89696/wechat_image_20190127144124.png?itok=NGTMnbVV&timestamp=1548663379",
  date: { year: 2019, month: 1, day: 27 },
  descriptionKey: {
    zh: "GGJ 2019 深圳站合作游戏，主题「家对你意味着什么」。爷爷要在新年前集齐全家人，但城市污染严重。管理氧气值在城市中探索，若氧气耗尽，痴呆症将降临，城市地图也会随之扭曲变形。",
    en: "GGJ 2019 Shenzhen collab, theme: What home means to you. Grandpa must gather his family before New Year, but the city is heavily polluted. Manage your oxygen to explore — let it run too low and dementia sets in, warping the city around you."
  },
  genres: ["冒险", "探索", "Game Jam"],
  themes: ["春节", "家庭", "污染"],
  platform: ["Android"],
  developerNotesKey: {
    zh: "GGJ 2019 深圳站合作作品，主题「家对你意味着什么」。有独特的痴呆症机制：氧气耗尽时城市地图会扭曲变形，让人很难找到回家的路。随进度推进，体力更强的年轻家庭成员会接替爷爷出门探索。",
    en: "GGJ 2019 Shenzhen collab, theme: What home means to you. Features a unique dementia mechanic — deplete your oxygen and the city map warps, making it hard to find your way home. As you progress, a younger family member takes over with greater range."
  },
  tags: ["Game Jam"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "video", url: "https://www.youtube.com/watch?v=Mf2IsBouln8", textKey: { zh: "游戏视频", en: "Gameplay Video" } }
  ]
};
